import { useEffect } from "react";

/**
 * Sets per-route <title>, meta description, and canonical link for SEO.
 * React Router renders a single HTML shell, so we manage head tags imperatively.
 */
export function useDocumentHead({ title, description, canonical, robots }) {
    useEffect(() => {
        if (title) document.title = title;

        if (description) {
            let m = document.querySelector('meta[name="description"]');
            if (!m) {
                m = document.createElement("meta");
                m.setAttribute("name", "description");
                document.head.appendChild(m);
            }
            m.setAttribute("content", description);
        }

        if (canonical) {
            let link = document.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", canonical);
        }

        // Robots meta (used to add noindex on NotFound)
        let r = document.querySelector('meta[name="robots"]');
        if (!r) {
            r = document.createElement("meta");
            r.setAttribute("name", "robots");
            document.head.appendChild(r);
        }
        r.setAttribute("content", robots || "index,follow,max-image-preview:large");
    }, [title, description, canonical, robots]);
}
